import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Container,
  Grid,
  Typography,
  Box,
  Hidden,
  Button,
  IconButton,
} from "@material-ui/core";
import MyMenu from "./MyMenu";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";
import clsx from "clsx";
import fontConfig from "../../constants/fonts";
import NavLinksDrawer from "./NavLinksDrawer";
import { useDispatch } from "react-redux";
import { openCommonPageModal } from "../../redux/action/utilActions";
import { Home } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
const useStyles = makeStyles((theme) => ({
  AppBar: {
    backgroundColor: "white",
    height: 50,
    // paddingTop: theme.spacing(1),
    padding: 0,
  },
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
  menuItemContainer: {
    // borderLeft: "0.5px solid",
    // borderRight: "0.5px solid",

    height: 50,
    minWidth: 130,
  },
  hasBorderLeft: {
    borderLeft: "1px solid",

    borderLeftColor: theme.palette.primary.dark,
  },
  hasBorderRight: {
    borderRight: "1px solid",

    borderRightColor: theme.palette.primary.dark,
  },
  menuBox: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    transition: "all 0.5s ease",
    color: "#444444",
    // borderTopLeftRadius: 20,
    // borderTopRightRadius: 20,

    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      color: "white",
      // borderTopLeftRadius: 20,
      // borderTopRightRadius: 20,
    },
  },
  menuTitle: {
    ...fontConfig.medium,
    fontSize: "1rem",
  },
  menuIcon: {
    marginLeft: "0.5vw",
  },
  gridContainer: {
    marginLeft: theme.spacing(3),
    display: "flex",
    alignItems: "center",
  },
  gridItem: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  btnContainer: {},
  addBtn: {
    // border: "2px solid #444",
    borderRadius: 500,
  },
}));

const NavLinks = ({ data }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const handleNavigate = () => {
    window.open("https://egrampanchayat.in/", "_self");
    // dispatch(
    //   openCommonPageModal({
    //     title: "તમારી ગ્રામ પંચાયત ઉમેરો",
    //     link: "addpanchayat",
    //   })
    // );
  };
  return (
    <>
      <div className={classes.root}>
        <DesktopHidden>
          <NavLinksDrawer
            data={data?.data}
            addBtnTitle={data?.addBtnTitle}
            logoUrl={data?.logoUrl}
          />
        </DesktopHidden>
        <MobileHidden>
          <AppBar position="static" className={classes.AppBar}>
            <Toolbar variant="dense">
              <div className={classes.gridContainer}>
                <div className={classes.gridItem}>
                  {data?.data?.map((nav, index) => {
                    return (
                      <div className={clsx(classes.menuItemContainer)}>
                        <Box className={classes.menuBox}>
                          <MyMenu
                            data={nav?.children || []}
                            link={nav?.link}
                            external={nav?.external}
                            isModal={nav?.isModal}
                            title={nav?.title}
                            datalink={nav?.datalink}
                            postlink={nav?.postlink}
                          >
                            <Typography className={classes.menuTitle}>
                              {nav.title}
                            </Typography>
                            {nav?.children?.length > 0 && (
                              <ArrowDown className={classes.menuIcon} />
                            )}
                          </MyMenu>
                        </Box>
                      </div>
                    );
                  })}
                </div>
                <div className={classes.btnContainer}>
                  <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    className={classes.addBtn}
                    onClick={() => handleNavigate()}
                  >
                    {data?.addBtnTitle}
                  </Button>
                </div>
              </div>
            </Toolbar>
          </AppBar>
        </MobileHidden>
      </div>
    </>
  );
};
export default NavLinks;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     [theme.breakpoints.down("md")]: {
//       backgroundColor: "white",
//     },
//   },
// }));

// const ComponentName = () => {
//   const classes = useStyles();

//   return (
//     <header id="header" class="header header-layout1">
//       {/* <div class="header__promo-text text-center">
//         <strong>Need Help:</strong>Providing Innovative and Sustainable
//         Solutions, Call (002) 01061245741
//       </div> */}
//       <nav class="navbar navbar-expand-lg sticky-navbar">
//         <div class="container-fluid px-0">
//           <a class="navbar-brand" href="index.html">
//             {" "}
//             <img
//               class="logo-light"
//               src="assets/images/logo/logo-light.png"
//               alt="logo"
//             />{" "}
//             <img
//               class="logo-dark"
//               src="assets/images/logo/logo-dark.png"
//               alt="logo"
//             />{" "}
//           </a>{" "}
//           <button class="navbar-toggler" type="button">
//             {" "}
//           </button>
//           <div id="mainNavigation" class="collapse navbar-collapse">
//             <ul class="navbar-nav mx-auto">
//               <li class="nav__item with-dropdown">
//                 <a
//                   class="dropdown-toggle nav__item-link active"
//                   href="index.html"
//                 >
//                   Home
//                 </a>
//                 <ul class="dropdown-menu">
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="index.html">
//                       Home Main
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="home-classic.html">
//                       Home classic
//                     </a>
//                   </li>
//                 </ul>
//               </li>
//               <li class="nav__item with-dropdown">
//                 <a class="dropdown-toggle nav__item-link" href="about-us.html">
//                   ઈતિહાસ
//                 </a>
//                 <ul class="dropdown-menu">
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="about-us.html">
//                       About Us
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="why-us.html">
//                       Why Choose Us
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="leadership-team.html">
//                       Leadership Team
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="awards.html">
//                       Award &amp; Recognition
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="pricing.html">
//                       Pricing &amp; Plans
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="faqs.html">
//                       Help &amp; FAQs
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="careers.html">
//                       careers
//                     </a>
//                   </li>
//                 </ul>
//               </li>
//               <li class="nav__item with-dropdown">
//                 <a
//                   class="dropdown-toggle nav__item-link"
//                   href="Industries-industry-served.html"
//                 >
//                   ધરોહર
//                 </a>
//                 <ul class="dropdown-menu wide-dropdown-menu">
//                   <li class="nav__item">
//                     <div class="row mx-0">
//                       <div class="col-sm-6 dropdown-menu-col">
//                         <h6>Industries Served</h6>
//                         <ul class="nav flex-column">
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-industry.html"
//                             >
//                               Petroleum &amp; Gas
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-industry.html"
//                             >
//                               Construction &amp; Engineering
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-industry.html"
//                             >
//                               Mechanical Engineering
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-industry.html"
//                             >
//                               Industrial Chemicals
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-industry.html"
//                             >
//                               Automotive Manufacturing
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-industry.html"
//                             >
//                               Bridge Construction
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                       <div class="col-sm-6 dropdown-menu-col">
//                         <h6>Industry Sectors</h6>
//                         <ul class="nav flex-column">
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-sector.html"
//                             >
//                               Retail &amp; Consumer
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-sector.html"
//                             >
//                               Sciences &amp; Healthcare
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-sector.html"
//                             >
//                               Industrial &amp; Chemical
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-sector.html"
//                             >
//                               Power Generation
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-sector.html"
//                             >
//                               Food &amp; Beverage
//                             </a>
//                           </li>
//                           <li class="nav__item">
//                             <a
//                               class="nav__item-link"
//                               href="industries-single-sector.html"
//                             >
//                               Oil &amp; Gas
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                   </li>
//                 </ul>
//               </li>
//               <li class="nav__item with-dropdown">
//                 <a
//                   class="dropdown-toggle nav__item-link"
//                   href="case-studies-grid.html"
//                 >
//                   પ્રવ્રુતિઓ
//                 </a>
//                 <ul class="dropdown-menu">
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="case-studies-grid.html">
//                       Case Studies Grid
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="case-studies-classic.html">
//                       Case Studies Classic
//                     </a>
//                   </li>
//                   <li class="nav__item">
//                     <a class="nav__item-link" href="case-studies-single.html">
//                       Single Case Study
//                     </a>
//                   </li>
//                 </ul>
//               </li>
//               <li class="nav__item with-dropdown">
//                 <a class="dropdown-toggle nav__item-link" href="blog.html">
//                   સિદ્ધિઓ
//                 </a>
//               </li>
//               <li class="nav__item with-dropdown">
//                 <a class="dropdown-toggle nav__item-link" href="blog.html">
//                   પદાધિકારી
//                 </a>
//               </li>{" "}
//               <li class="nav__item with-dropdown">
//                 <a class="dropdown-toggle nav__item-link" href="blog.html">
//                   યોજનાઓ
//                 </a>
//               </li>{" "}
//               {/* <li class="nav__item with-dropdown">
//                 <a class="dropdown-toggle nav__item-link" href="blog.html">
//                   વિકાસના કામ
//                 </a>
//               </li>{" "} */}
//               {/* <li class="nav__item">
//                 <a class="nav__item-link" href="contacs.html">
//                   બ્લડ ગ્રુપની માહિતી
//                 </a>
//               </li> */}
//             </ul>
//           </div>
//           <div class="navbar-modules">
//             <ul class="list-unstyled d-flex align-items-center modules__btns-list">
//               <li>
//                 <div class="dropdown dropdown__lang">
//                   <button
//                     id="langDrobdown"
//                     class="dropdown-toggle"
//                     data-toggle="dropdown"
//                   >
//                     {" "}
//                     {/* <img src="assets/images/flags/en.png" alt="en" /> */}
//                     ગુજરાતી
//                   </button>
//                   <div class="dropdown-menu">
//                     <a class="dropdown-item" href="#">
//                       {" "}
//                       <img src="assets/images/flags/en.png" alt="fr" />
//                       English
//                     </a>{" "}
//                     {/* <a class="dropdown-item" href="#">
//                       {" "}
//                       <img src="assets/images/flags/gr.png" alt="gr" />
//                       germany{" "}
//                     </a> */}
//                   </div>
//                 </div>
//               </li>
//               {/* <li class="d-none d-lg-block">
//                 <a
//                   class="btn btn__secondary module__btn-request"
//                   href="request-quote.html"
//                 >
//                   {" "}
//                   Request A Quote{" "}
//                 </a>
//               </li> */}
//               <li class="d-none d-lg-block">
//                 <form class="header__search-form">
//                   <input
//                     class="search__input"
//                     type="text"
//                     placeholder="Search..."
//                   />{" "}
//                   <button></button>
//                 </form>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </header>
//   );
// };
// export default ComponentName;
